import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { MyTeamLifeCycle } from "../../types/LC.Types";
import "./ExcelExportButton.css";
import BaseButton from "../Base/BaseButton/BaseButton";


interface Props<T> {
  data: T[];
  filename: string;
  sheetName: string;
}

const ExcelExportButton = <T,>({
  data,
  filename,
  sheetName
}: Props<T>) => {
  const exportToExcel = () => {
    if (!data || data.length === 0) return;

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(file, filename);
  };

  return (
    <BaseButton variant="primary" onClick={exportToExcel}>
      Export to Excel
    </BaseButton>
  );
};

export default ExcelExportButton;
